export default "__VITE_ASSET__5ADD0lio__"